import { FleetDto, Maybe } from "generated/graphql";

export function getFleetLabel(fleet: Maybe<FleetDto> | undefined) {
  if (fleet?.shortName || fleet?.name) {
    const hasId = fleet.legacyCompanyId !== null && fleet.legacyCompanyId !== undefined;
    return `${hasId ? `${fleet.legacyCompanyId} - ` : ""}${fleet.shortName || fleet.name}`;
  }
  return "";
}
